<wiz-root>
    <menu-bar></menu-bar>
    <router-outlet></router-outlet>
    <information-bar></information-bar>
</wiz-root>
